import {
  ConvertResDocument,
  ConvertResMutationResult,
  ConvertResMutationVariables,
} from "@graphql/api";

export default async function convertRes(resId: number): Promise<boolean> {
  const client = global.window.apolloClient;
  const mutVars: ConvertResMutationVariables = { resId };
  const result: ConvertResMutationResult = await client.mutate({
    mutation: ConvertResDocument,
    variables: mutVars,
  });

  return result.data?.convertRes?.success || false;
}
